export default __webpack_public_path__ + "3eb06c702e27fb110194f5a16c45cb8e.woff2";